import React, { useEffect, useState } from 'react';
import useClickedOutside from '../../hooks/useClickedOutside';

export default function SleekChangelog({
}) {

  const [open, setOpen] = useState(false);

  const containerRef = useClickedOutside(() => {
    try {
      window.$sleek.close();
    } catch (e) {
      // swallow
    }
  });

  useEffect(() => {
    // keep track of sleek open state
    window.document.addEventListener("sleek:open", function () {
      setOpen(true);
    });
    window.document.addEventListener("sleek:close", function () {
      setOpen(false);
    });
    return () => {
      try {
        window.$sleek.close();
      } catch (e) {
        // swallow
      }
    };
  }, []);

  return (
    <a
      ref={containerRef}
      className="changelog"
      data-tiny-changelog
      onClick={(e) => {
        window.$sleek.toggle("tiny.changelog");
      }}
    >
      <span data-badge-changelog></span>
      What's new
    </a>
  );


}
